export const purchaseOrderStatus = {
	released: "Released",
	partReceived: "PartReceived",
	fullyReceived: "FullyReceived",
	completed: "Completed",
	cancelled: "Cancelled",
};
